import { produce } from "immer"
import types from "./types"

export type NewsletterState = {
  error?: boolean
  email?: string
  subscribed?: boolean
}

export const initialState: NewsletterState = Object.freeze({
  email: "",
  subscribed: false,
})

export default function reducer(state = initialState, action: { type: string; payload: any }) {
  return produce(state, (writableState) => {
    switch (action.type) {
      case types.SUBSCRIBE.SUCCESS:
        writableState.subscribed = true
        writableState.error = false
        break
      case types.SUBSCRIBE.FAILURE:
        writableState.subscribed = false
        writableState.error = true
        break
      case types.UNSUBSCRIBE.SUCCESS:
        writableState.subscribed = false
        writableState.error = false
        break
      case types.UNSUBSCRIBE.FAILURE:
        writableState.subscribed = true
        writableState.error = true
        break
      default:
        return writableState
    }
    return writableState
  })
}
